import {gql} from '@apollo/client';

export const QUERY_VIEW_LIST = gql`
  query ViewList($forumId: ID) {
    viewList(forum: $forumId) {
      id
      userId
    }
  }
`;

export const MUTATION_VIEW_SAVE = gql`
  mutation ViewSave($input: ViewSaveInput!) {
    viewSave(input: $input) {
      obj {
        id
        userId
        forum {
          id
          viewsCount
        }
      }
    }
  }
`;
